/* eslint-disable max-len */
import Alert from './Alert';
import ShowMeMore from './ShowMeMore';

export default function CancellationPolicy({ data }) {
  const alert = [
    {
      text: 'Come tested or vaccinated – If you are not fully vaccinated please do an antigen self-test at home before you leave or at a local test center.',
    },
    {
      text: 'Keep distance – Please keep a safe distance of 1,5 m between each other whenever possible',
    },
    {
      text: 'Wear masks – Please wear a mask (FFP2/surgical) when indoors or when the minimum distance cannot be upheld',
    },
  ];

  return (
    <div className="mt-16 md:pt-8 items-baseline gap-16 border-t border-solid border-dark-50 lg:grid lg:grid-cols-2 lg:gap-12">
      <div>
        <ShowMeMore textLimit={310} title={data?.attributes?.title} text={data?.attributes?.text} />
      </div>
      <div>
        <Alert spacing measures={alert} title="COVID-19 measures" />
      </div>
    </div>
  );
}
